<template>
	<div class="">
		<div v-if="!register">
			<img class="logo" v-if="name.startsWith('http')" :src="name" />
			<h1 class="logo" v-else>{{ name }}</h1>
			<b-form @submit="onSubmit">
				<b-form-group
					id="user_group"
					:label="label_login || $t('connect.login')"
					label-for="user">
					<b-form-input
						id="user"
						type="text"
						v-model="form.user"
						required
						:placeholder="$t('connect.login')"></b-form-input>
				</b-form-group>
				<b-form-group
					id="pwd_group"
					:label="$t('connect.password')"
					label-for="pwd">
					<b-form-input
						id="pwd"
						type="password"
						v-model="form.pwd"
						required
						:placeholder="$t('connect.password')"></b-form-input>
				</b-form-group>
				<b-button type="submit" variant="primary">{{ $t('ui.validate') }}</b-button>
			</b-form>
			<p style="margin-top: 10px">
				<a href="/password_reset">{{ $t('connect.forgotten_password') }}</a>
			</p>
			<div>
				<b-alert v-if="error" show>{{ errorMsg }}</b-alert>
			</div>

			<p v-if="register_page" style="margin-top: 10px">
				<b-button style="padding:0px" @click="register = true" variant="link">{{ $t('connect.create') }}</b-button>
			</p>
		</div>
		<div v-else>
			<register :login="true" :_token="register_page_token" @register="register = false"></register>
			<b-button style="padding:0px" @click="register = false" variant="link">{{ $t('connect.connect_account') }}</b-button>
		</div>
	</div>
</template>

<script>
	import login from "../services/login.js";
	import users from "../services/users.js";
	import register from "./Register.vue";
	import store from "../store";

	export default {
		name: "login",
		components: {
			register
		},
		data() {
			return {
				register: false,
				label_login: process.env.VUE_APP_LABEL_LOGIN,
				register_page: process.env.VUE_APP_REGISTER,
				register_page_token: process.env.VUE_APP_REGISTER_TOKEN,
				form: {
					user: "",
					pwd: "",
				},
				error: false,
				errorMsg: null,
				name: process.env.VUE_APP_NAME || this.$t('smartmydata'),
			};
		},
		methods: {
			onSubmit(evt) {
				evt.preventDefault();
				login
					.auth(this.form.user, this.form.pwd)
					.then(async (res) => {
						let jwt = res.data.jwt;
						this.$store.commit("setJwt", jwt);

						var response = await users.getSelf(true);
						this.$store.commit("setUser", response.user);						

						this.$emit("loginSuccess");
						this.$router.push({ name: "main" });
					})
					.catch((error) => {

						console.log("login failed")
						console.log(error.response.data.msg)
						
						this.error = true;

						if (error.response.data.msg == this.$t('connect.archived_account'))
							this.errorMsg = this.$t('connect.no_active_account')
						else
							this.errorMsg = this.$t('connect.invalid_credentials');
					});
			},
		},
	};
</script>

<style>
	.baground {
		margin-right: 250px;
	}
	.logo {
		text-align: center;
		margin-left: auto;
		margin-right: auto;
		max-width: 100%;
		max-height: 100%;
		display: block;
	}
</style>
